import moment, { Moment, MomentInput } from 'moment/moment';
import isDate from 'validator/lib/isDate';

export const minDateValue = moment.min;
export const maxDateValue = moment.max;

export type DateValue = Moment;

export type RawDateValue =
  | `${number}.${number}.${number}`
  | `${number}-${number}-${number}`;

export type DateTimeValue =
  | `${number}.${number}.${number} ${number}:${number}`
  | `${number}-${number}-${number} ${number}:${number}`;

export function getCurrentDateValue(): Moment {
  return moment.utc();
}

export function parseRawDateValue(
  value: RawDateValue | string,
  format = 'DD.MM.YYYY',
): Moment {
  return moment.utc(value, format);
}

export function formatDateValue(
  value: MomentInput,
  format = 'DD.MM.YYYY',
): RawDateValue {
  return moment.utc(value).format(format) as RawDateValue;
}

// rsuite DateRangePicker / DatePicker отдают JS Date в локальной TZ
// браузера (полночь выбранной даты). Прогон такого Date через
// `formatDateValue` (moment.utc) для юзера в положительной TZ
// сдвигает дату назад на день. Этот хелпер берёт Y/M/D в локальной TZ
// и сериализует их в `RawDateValue`, чтобы round-trip с
// `parseRawDateValue` был идемпотентен независимо от TZ браузера.
// Формат намеренно зашит — у пикера нет временной составляющей,
// и любой формат со временем дал бы артефактный `00:00`.
export function formatPickerDateValue(date: Date): RawDateValue {
  return moment
    .utc([date.getFullYear(), date.getMonth(), date.getDate()])
    .format('DD.MM.YYYY') as RawDateValue;
}

export function parseDateTimeValue(
  value: DateTimeValue | string,
  format = 'DD.MM.YYYY HH:mm',
): Moment {
  return moment.utc(value, format);
}

export function formatDateTimeValue(
  value: MomentInput,
  format = 'DD.MM.YYYY HH:mm',
): DateTimeValue {
  return moment.utc(value).format(format) as DateTimeValue;
}

export function formatCalendar(value: MomentInput): string {
  const date = moment(value);
  return date.startOf('day').calendar(null, {
    lastDay: '[Вчера]',
    sameDay: '[Сегодня]',
    nextDay: '[Завтра]',
    lastWeek: function (m) {
      const now = moment(m);
      if (now?.week() !== date.week()) {
        switch (date.day()) {
          case 0:
            return '[Прошлое] dddd';
          case 1:
          case 2:
          case 4:
            return '[Прошлый] dddd';
          case 3:
          case 5:
          case 6:
            return '[Прошлая] dddd';
          default:
            return '';
        }
      } else {
        if (date.day() === 2) {
          return '[Во] dddd';
        } else {
          return '[В] dddd';
        }
      }
    },
    nextWeek: 'dddd',
    sameElse: 'L',
  });
}
